import { Parameters } from '@web/common';
import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';

export enum GraphTypes {
  VALUE = 'value',
  COMPARISON = 'comparison',
  CATEGORY = 'category',
}

export enum ReportCategories {
  FITNESS = 'fitness',
  HEART = 'heart',
  STRESS = 'stress',
}

export function getReportCategoryFromParameter(parameter: Parameters) {
  switch (parameter) {
    case Parameters.BODY_WEIGHT:
    case Parameters.FAT_PERCENTAGE:
    case Parameters.FAT_MASS:
    case Parameters.MUSCLE_PERCENTAGE:
    case Parameters.MUSCLE_MASS:
    case Parameters.BODY_MASS_INDEX:
    case Parameters.PHYSICAL_FITNESS:
      return ReportCategories.FITNESS;
    case Parameters.BLOOD_PRESSURE:
    case Parameters.BLOOD_PRESSURE_SYSTOLIC:
    case Parameters.BLOOD_PRESSURE_DIASTOLIC:
    case Parameters.PULSE:
    case Parameters.CARDIO_FITNESS:
    case Parameters.HEART_STRENGTH:
      return ReportCategories.HEART;
    case Parameters.CARDIOVASCULAR_RISK:
    case Parameters.STRESS_LEVEL:
      return ReportCategories.STRESS;
  }
}

export interface parameterHistoryData {
  date: Date;
  series1: number;
  series2?: number;
}

export interface comparisonParameterHistoryData {
  date: Date;
  series: [number, number];
}

export interface categoryParameterHistoryData {
  date: Date;
  series: number;
}

export const measurementDataEntry = z.object({
  value: z.number(),
  thresholds: z.array(z.number()),
  colors: z.array(z.string()),
  unit: z.string(),
});

export const measurementData = z.object({
  BloodPressureSystolic: measurementDataEntry,
  BloodPressureDiastolic: measurementDataEntry,
  BodyWeight: measurementDataEntry,
  FatPercentage: measurementDataEntry,
  FatMass: measurementDataEntry,
  MusclePercentage: measurementDataEntry,
  MuscleMass: measurementDataEntry,
  BodyMassIndex: measurementDataEntry,
  PhysicalFitness: measurementDataEntry,
  CardioFitness: measurementDataEntry,
  HeartStrength: measurementDataEntry,
  CardiovascularRisk: measurementDataEntry,
  Pulse: measurementDataEntry,
  StressLevel: measurementDataEntry,
});

export class MeasurementData extends createZodDto(measurementData) {}

export const measurementDataWithIdAndDate = z.object({
  id: z.string(),
  date: z.string(),
  dataSet: measurementData,
});

export class MeasurementDataWithIdAndDate extends createZodDto(
  measurementDataWithIdAndDate,
) {}

export const measurement = z.object({
  id: z.string(),
  timestamp: z.string(),
});

export class Measurement extends createZodDto(measurement) {}

export const measurementsDto = z.array(measurement);

export class MeasurementsDto extends createZodDto(measurementsDto) {}
